import CalendarComponent from './Calendar';

export default CalendarComponent;
